import * as React from 'react';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import { AdvancedConfiguration, keyCafeKeyGroups, KeyCafePropertyConfiguration } from '../../../../../api/PropertyIntegration';
import {  useState } from 'react';
import FormSelectLabeled from '../../../../common/form/SelectLabeled';	
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';																  
import Checkbox from '../../../../common/form/Checkbox';
import MinimalMultiSelect from '../../../../common/MinimalMultiSelect';
import FormInput from '../../../../common/form/Input';

interface Props {
    propertyId: number;
    currentCompanyId: number;
    advanceConfiguration: AdvancedConfiguration;
    reload: () => Promise<void>;
    setIsLoading: (isLoading: boolean) => void;
    update: (newConfig?: KeyCafePropertyConfiguration) => void;
    updateKeys: (newKeys?: any)=> void;
    isFormSubmitted: boolean;
    setIsFormSubmitted: any;
    keyLocations?: any;
    keyCafePropertyConfiguration?: KeyCafePropertyConfiguration;
    keyGroups?: keyCafeKeyGroups[];
    keyCafeKeys?: any;
}

const KeyCafeConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();

    const [isCardOpen, setIsCardOpen] = useState<boolean>(!!props.keyCafePropertyConfiguration);
			 
    return (
        <>
            <CollapsibleCard
                cardTitle="KeyCafe Configuration"
                cardOpen={!!props.keyCafePropertyConfiguration}
                onCardOpenChange={(open) => {
                    if (isUser)  return;
                    setIsCardOpen(open);
                    if (!open) {


                    }
                    props.setIsFormSubmitted(false);
                    props.update(open ? {Id: 0, keyCafeKeyGroupId: '', keyCafeLocationId: '', notify: false, emailList: '' } : undefined);
                }}
            >
                 {props.keyCafePropertyConfiguration && isCardOpen ? (
                    <div>
                        { props.keyLocations && <FormSelectLabeled
                            selectProps={{
                                id: 'key-cafe-location-id',
                                name: 'KeyCafeLocationId',
                                value: props.keyCafePropertyConfiguration.keyCafeLocationId,
                                required: true,
                                disabled: isUser
                            }}
                            labelProps={{
                                labelText: 'KeyCafe Location Id',
                                invalidText: 'Please select a valid KeyCafe Location ID',		   
                            }}
                            onChange={(_name, value: string) => {
                                !isUser && props.update({
                                    ...props.keyCafePropertyConfiguration!,
                                    keyCafeLocationId: value,  
                                });
                            }}
                            selectOptions={props.keyLocations.map((group: any) => ({ label: group.name, value: group.id }))}
                        />}

                       { props.keyGroups && <FormSelectLabeled
                            selectProps={{
                                id: 'key-group-id',
                                name: 'KeyCafeKeyGroupId',
                                value: props.keyCafePropertyConfiguration.keyCafeKeyGroupId,
                                required: true,
                                disabled: isUser
                            }}
                            labelProps={{
                                labelText: 'KeyGroup Id',
                                invalidText:  'Please select a valid KeyGroup ID',		   
                            }}
                            onChange={(_name, value: string) => {
                                !isUser && props.update({
                                    ...props.keyCafePropertyConfiguration!,
                                    keyCafeKeyGroupId: value,  
                                });
                            }}
                            selectOptions={props.keyGroups.map((group) => ({ label: group.name, value: String(group.id) }))}
                        />}

                        <label id="key-cafe-location-id-label" style={{ fontWeight: 'bold', fontSize: '10px' }}>KEYCAFE KEYS</label>
                        { props.keyCafeKeys && <MinimalMultiSelect 
                           heading={props.advanceConfiguration.keyCafePropertyKeys.map((group: any) => group.keyId).length>0?  props.advanceConfiguration.keyCafePropertyKeys.map((group: any) => group.keyId).length + ( props.advanceConfiguration.keyCafePropertyKeys.map((group: any) => group.keyId).length ===1? ' Key Selected': ' Keys Selected'): 'Select Keys'} 
                           listItems={props.keyCafeKeys.map((group: any) => ({ name: group.keyName, id: group.keyId }))} 
                           selectedIds={props.advanceConfiguration.keyCafePropertyKeys.map((group: any) => group.keyId)}
                           setSelectedIds={function (ids: any[]): void {
                            const selectedKeys = props.keyCafeKeys.filter((key: any) => ids.includes(key.keyId));
                            props.updateKeys(selectedKeys);
                           }}
                        />
                        }

                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '12px', alignItems: 'center' }}>
                                <Checkbox
                                    toggle={true}
                                    onChange={() => {
                                        const newNotifyValue = !props.keyCafePropertyConfiguration!.notify;

                                        !isUser && props.update({
                                            ...props.keyCafePropertyConfiguration!,
                                            notify: newNotifyValue,
                                            emailList: newNotifyValue ? '' : props.keyCafePropertyConfiguration!.emailList,
                                        });
                                    }}
                                    inputProps={{
                                        id: `card-open-notify`,
                                        name: `notify`,
                                        checked:  props.keyCafePropertyConfiguration!.notify,
                                    }}
                                />
                                <span style={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '10px', marginLeft: '8px' }}>
                                    send email when keycard/key may not have been returned
                                </span>
                            </div>
                            {
                                props.keyCafePropertyConfiguration && props.keyCafePropertyConfiguration!.notify &&
                                <div style={{ marginTop: '8px' }}>
                                    <FormInput
                                        labelProps={{
                                            labelText: 'Emails',
                                            invalidText: 'enter comma seperated emails'
                                        }}
                                        inputProps={{
                                            id: 'masterlock-sharing-emails',
                                            name: 'emails',
                                            value: props.keyCafePropertyConfiguration!.emailList,
                                            type: 'string',
                                            required: true
                                        }}
                                        onChange={(_name, value: string) =>
                                            !isUser && props.update({
                                                ...props.keyCafePropertyConfiguration!,
                                                emailList: value!== "" ? value : ""
                                            })
                                        }
                                    />
                                </div>
                            }
                    </div>
                ) : (
                    <div />
                )}
            </CollapsibleCard>
        </>
    );
};

export default KeyCafeConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/KeyCafeConfigurationSection.tsx